import React from "react";

function CancelButton() {
  return (
    <div>
      {" "}
      <button className="bg-gray-500 rounded-lg text-white font-bold text-[12px] py-2 px-2">
        {" "}
        Cancel{" "}
      </button>
    </div>
  );
}

export default CancelButton;
